import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Form } from "antd";
import config from "Configurations";
import ReCAPTCHA from "react-google-recaptcha";
import styles from "./styles.module.scss";


const Representation = ({
  loading,
  verifyRecaptcha,
  form,
  signUp,
  organizationName
}) => {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <div className={styles.carouselContent}>
        <div style={{ width: "100%" }}>
          <img style={{ width: "100%" }} src="/assets/pivony-logo1.png" alt="logo" />
        </div>

        <div className={styles.title}>
          <h1>{t("landing_appsumo.invited_join", "You are invited to join")}</h1>
          <h1><i>{decodeURI(organizationName.replaceAll("%20"," "))}</i></h1>
        </div>
        <div>
          <Form form={form} name="mainDetails" onFinish={signUp}>
            <Form.Item
              name="firstName"
              label={t("landing_appsumo.first_name", "First name")}
              rules={[{ required: true, message: t("signup_page.first_name_required", "First name is required") }]}
            >
              <input placeholder="John" className={styles.inputForm} />
            </Form.Item>
            <Form.Item
              name="lastName"
              label={t("landing_appsumo.last_name", "Last name")}
              rules={[{ required: true, message: t("signup_page.last_name_required", "Last name is required") }]}
            >
              <input placeholder="Doe" className={styles.inputForm} />
            </Form.Item>
            <Form.Item
              name="password"
              label={t("landing_appsumo.password", "Password")}
              rules={[{ required: true, message: t("signup_page.password_required", "Password is required") }]}
            >
              <input type="password" className={styles.inputForm} />
            </Form.Item>
            <Form.Item
              name="confirmPassword"
              label={t("landing_appsumo.confirm_password", "Confirm your password")}
              rules={[{ required: true, message: t("signup_page.password_required", "Password is required") }]}
            >
              <input type="password" className={styles.inputForm} />
            </Form.Item>
            <Form.Item style={{ textAlign: "center" }}>
              <div className={styles.recaptcha}>
                <ReCAPTCHA
                  style={{ display: "inline-block" }}
                  onChange={verifyRecaptcha}
                  sitekey={config.RECAPTCHA_SITE_PUBLIC_KEY}
                />
              </div>
              <Button
                loading={loading}
                className={styles.btn}
                type="primary"
                htmlType="submit"
                style={{ height: "auto" }}
              >
                {t("landing_appsumo.sign_up", "Sign up")}
              </Button>
            </Form.Item>
            <Form.Item style={{ textAlign: "center" }}>
              <p className={styles.terms}>
                {t("landing_appsumo.terms_agree", "By clicking the button above, you agree to our")} <br />
                <a href="https://pivony.com/terms/" target="_blank" rel="noopener noreferrer">
                  {t("landing_appsumo.terms_of_service", "Terms of Service")}
                </a>{" "}
                {t("landing_appsumo.and", "and")}{" "}
                <a href="https://pivony.com/privacy/" target="_blank" rel="noopener noreferrer">
                  {t("landing_appsumo.privacy_policy", "Privacy Policy")}
                </a>
              </p>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default Representation;
